import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PagerData } from './../../business-entities/PagerData';
import { Constant } from '../../../../../Autofacets-Core/src/app/utils/constant';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit,OnChanges {

  pagerData: PagerData = new PagerData();
  options: number[] = [];

  @Input() pager;
  @Output() setPageEvent: EventEmitter<PagerData> = new EventEmitter<PagerData>();
  @Input() recordSize;
  
  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    // This is intentional
  }

  ngOnChanges(changes: SimpleChanges) {
    this.options = [];
    this.options.push(10);
    this.options.push(20);
    this.options.push(30);
    if (changes['pager']) {
      if (this.pager.totalItems > Constant.GridPagerSize) {
        for (let i = 10; i <= 30 && i < this.pager.totalItems; i = i + 10) {
          if (this.options.indexOf(i) < 0) {
            this.options.push(i);
          }
        }
      }
    }
    this.pagerData = { page: this.pager.currentPage, pagerSize: this.pager.pageSize };
  }

  setPage(page: number, pagerSize: number) {
    this.pagerData.page = Number(page);
    this.pagerData.pagerSize = Number(pagerSize);
    this.setPageEvent.emit(this.pagerData);
  }

  calcShowingCount() {
    if (this.pager == null || this.pager === undefined || this.pager.currentItems === undefined) {
      return '';
    } else {
      if (this.pager.endIndex < 0 && this.pager.startIndex < 0) {
        return '';
      }

      return this.translateService.instant('Paging.Showing')
        + ' '
        + (this.pager.startIndex + 1).toString()
        + ' - '
        + (this.pager.endIndex + 1).toString();
    }
  }

}
